(()=>{'use strict';
const one=(q,root=document)=>root.querySelector(q);
const all=(q,root=document)=>Array.from(root.querySelectorAll(q));
const cachedCutouts=new Map();
const generatedBlobs=new Set();
async function cutout(url){
 if(cachedCutouts.has(url))return cachedCutouts.get(url);
 const task=new Promise((resolve,reject)=>{
   const photo=new Image();photo.crossOrigin='anonymous';photo.decoding='async';
   photo.onload=()=>{
     try{
       const scale=Math.min(1,760/Math.max(photo.naturalWidth,photo.naturalHeight)),w=Math.max(1,Math.round(photo.naturalWidth*scale)),h=Math.max(1,Math.round(photo.naturalHeight*scale));
       const canvas=document.createElement('canvas');canvas.width=w;canvas.height=h;
       const ctx=canvas.getContext('2d',{willReadFrequently:true});if(!ctx)throw Error('Canvas unavailable');
       ctx.drawImage(photo,0,0,w,h);
       const frame=ctx.getImageData(0,0,w,h),rgba=frame.data,length=w*h;
       const background=new Uint8Array(length),queue=new Int32Array(length);
       let front=0,back=0;
       function isOutside(pos){
         const p=pos*4,r=rgba[p],g=rgba[p+1],b=rgba[p+2];
         return Math.min(r,g,b)>=205&&Math.max(r,g,b)-Math.min(r,g,b)<32;
       }
       function seed(pos){if(!background[pos]&&isOutside(pos)){background[pos]=1;queue[back++]=pos}}
       for(let x=0;x<w;x++){seed(x);seed((h-1)*w+x)}
       for(let y=1;y<h-1;y++){seed(y*w);seed(y*w+w-1)}
       while(front<back){
         const pos=queue[front++],x=pos%w;
         if(x>0)seed(pos-1);
         if(x<w-1)seed(pos+1);
         if(pos>=w)seed(pos-w);
         if(pos<length-w)seed(pos+w);
       }
       if(back<length*.025)throw Error('Unrecognized background');
       for(let pos=0;pos<length;pos++)if(background[pos])rgba[pos*4+3]=0;
       ctx.putImageData(frame,0,0);
       canvas.toBlob(blob=>{if(!blob){reject(Error('Could not prepare overlay'));return}const ref=URL.createObjectURL(blob);generatedBlobs.add(ref);resolve(ref)},'image/png');
     }catch(error){reject(error)}
   };
   photo.onerror=()=>reject(Error('Image unavailable'));
   photo.src=url;
 });
 cachedCutouts.set(url,task);
 return task;
}
for(const panel of all('[data-wib-tryon-modal]')){
 const container=panel.closest('[data-vault-content]')||document;
 const open=one('[data-wib-tryon-open]',container);
 const closeButtons=all('[data-wib-tryon-close]',panel);
 const stage=one('[data-wib-tryon-stage]',panel),video=one('[data-wib-tryon-video]',panel),placement=one('[data-wib-tryon-placement]',panel),garment=one('[data-wib-tryon-garment]',panel),notice=one('[data-wib-tryon-loading]',panel);
 const size=one('[data-wib-size]',panel),height=one('[data-wib-height]',panel),opacity=one('[data-wib-opacity]',panel);
 const flip=one('[data-wib-tryon-flip]',panel),reset=one('[data-wib-tryon-reset]',panel);
 if(!open||!stage||!video||!placement||!garment||!notice||!size||!height||!opacity)return;
 let stream=null,facing='user',previousFocus=null,request=0,drag=null,left=50,active=false;
 const initialImage=garment.getAttribute('src');
 function refresh(){
   placement.style.width=size.value+'%';placement.style.top=height.value+'%';placement.style.left=left+'%';placement.style.opacity=String(Number(opacity.value)/100);
 }
 function resetPosition(){size.value='73';height.value='54';opacity.value='92';left=50;refresh()}
 function stop(){if(stream){stream.getTracks().forEach(track=>track.stop());stream=null}video.srcObject=null}
 async function start(){
   const ticket=++request;stop();
   notice.hidden=false;notice.textContent='REQUESTING CAMERA ACCESS…';
   if(!window.isSecureContext||!navigator.mediaDevices||!navigator.mediaDevices.getUserMedia){
     notice.textContent='CAMERA IS UNAVAILABLE HERE. OPEN THE SHOPIFY PREVIEW IN A SECURE BROWSER TAB ON YOUR PHONE.';return;
   }
   try{
     const media=await navigator.mediaDevices.getUserMedia({audio:false,video:{facingMode:{ideal:facing},width:{ideal:720},height:{ideal:1280}}});
     if(ticket!==request||!active){media.getTracks().forEach(t=>t.stop());return}
     stream=media;video.srcObject=media;video.style.transform=facing==='user'?'scaleX(-1)':'none';
     try{await video.play()}catch(e){}
     if(ticket!==request||!active)return;
     notice.hidden=true;
   }catch(error){
     if(ticket!==request)return;
     const blocked=error&&(error.name==='NotAllowedError'||error.name==='PermissionDeniedError');
     notice.textContent=blocked?'CAMERA PERMISSION DENIED. ALLOW CAMERA ACCESS IN YOUR BROWSER AND TRY AGAIN.':'CAMERA NOT AVAILABLE. OPEN THE SHOPIFY PREVIEW IN A NEW BROWSER TAB, OR CHECK YOUR CAMERA PERMISSIONS.';
   }
 }
 function prepareImage(){
   const src=initialImage;
   if(/\.png(?:\?|$)/i.test(src))return;
   placement.dataset.cutout='pending';
   cutout(src).then(url=>{
     if(garment&&!garment.dataset.manualImage){garment.src=url;garment.style.mixBlendMode='normal'}
     placement.dataset.cutout='ready';
   }).catch(()=>{
     // Keep the original mockup visible if the CDN doesn't permit canvas editing.
     placement.dataset.cutout='unavailable';
     garment.style.mixBlendMode='multiply';
   });
 }
 function show(){
   previousFocus=document.activeElement;active=true;panel.hidden=false;
   document.body.classList.add('wib-camera-open');resetPosition();panel.dataset.cameraOpen='true';
   const close=one('.wib-camera-close',panel);close?.focus();
   prepareImage();start();
 }
 function hide(){
   if(!active)return;active=false;request++;stop();panel.hidden=true;
   document.body.classList.remove('wib-camera-open');
   if(previousFocus&&typeof previousFocus.focus==='function')previousFocus.focus();
 }
 open.addEventListener('click',show);
 closeButtons.forEach(button=>button.addEventListener('click',hide));
 flip?.addEventListener('click',()=>{if(active){facing=facing==='user'?'environment':'user';start()}});
 reset?.addEventListener('click',resetPosition);
 [size,height,opacity].forEach(input=>input.addEventListener('input',refresh));
 placement.addEventListener('pointerdown',event=>{
   if(event.button!==0&&event.pointerType==='mouse')return;
   event.preventDefault();drag={x:event.clientX,y:event.clientY,startLeft:left,startTop:Number(height.value)};
   try{placement.setPointerCapture(event.pointerId)}catch(e){}
 });
 placement.addEventListener('pointermove',event=>{
   if(!drag)return;const box=stage.getBoundingClientRect();
   left=Math.min(95,Math.max(5,drag.startLeft+(event.clientX-drag.x)/box.width*100));
   height.value=String(Math.min(90,Math.max(10,drag.startTop+(event.clientY-drag.y)/box.height*100)));
   refresh();
 });
 const done=()=>{drag=null};
 placement.addEventListener('pointerup',done);placement.addEventListener('pointercancel',done);
 panel.addEventListener('keydown',event=>{
   if(event.key==='Escape'){event.preventDefault();hide();return}
   if(event.key!=='Tab')return;
   const focusable=all('button:not(:disabled),input:not(:disabled)',panel).filter(el=>el.offsetParent!==null);
   if(!focusable.length)return;
   const first=focusable[0],last=focusable[focusable.length-1];
   if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
   else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
 });
 document.addEventListener('visibilitychange',()=>{if(document.hidden&&active)hide()});
 window.addEventListener('pagehide',()=>{if(active)hide()});
}
for(const box of all('[data-wib-visual-modes]')){
 const photo=one('[data-wib-photo-panel]',box.parentElement);
 const model=one('[data-wib-model-panel]',box.parentElement);
 if(!photo||!model)continue;
 const buttons=all('[data-wib-mode]',box);
 const switchTo=kind=>{
   const isModel=kind==='model';photo.hidden=isModel;model.hidden=!isModel;
   buttons.forEach(b=>{const selected=b.dataset.wibMode===kind;b.setAttribute('aria-pressed',String(selected))});
 };
 buttons.forEach(b=>b.addEventListener('click',()=>switchTo(b.dataset.wibMode)));
 switchTo('angles');
}
window.addEventListener('pagehide',()=>{for(const url of generatedBlobs)URL.revokeObjectURL(url)});
})();